import styled from "styled-components";
import theme from "../../theme/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;

  input {
    width: 100%;
    font-size: 1em;
    border-bottom: 1px solid ${theme.colors.gray1};
    color: ${theme.colors.black1};
  }

  input:focus {
    border-color: ${theme.colors.primaryStrong};

    & + label {
      color: ${theme.colors.primaryStrong};
    }
  }

  label {
    color: ${theme.colors.gray1};
    margin-top: 5px;
  }

  .error {
    height: 13px;
    color: red;
    font-size: 12px;
  }
`;

const Input = ({ value, label, error, onChange, ...props }) => {
  return (
    <Wrapper>
      <input type="text" value={value || ""} {...props} onChange={onChange} />
      <label htmlFor="">{label}</label>
      {error && <span className="error">{error.errorMessage}</span>}
    </Wrapper>
  );
};

export default Input;
